import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Range } from "rc-slider";
import NumberFormat from "react-number-format";
import "./rateSlider.css";

const RateSlider = (props: {
  onChange?: (e: Array<number>) => void;
  value?: number[];
}) => {
  const [lowerBound, setLowerBound] = useState<number>(100000);
  const [upperBound, setUpperBound] = useState<number>(500000);

  useEffect(() => {
    if (props.value) {
      setLowerBound(props.value[0]);
      setUpperBound(props.value[1]);
    }
  }, [props.value]);

  useEffect(() => {
    if (props.onChange) props.onChange([lowerBound, upperBound]);
  }, [lowerBound, upperBound, props]);

  const handleChange = (e: Array<number>) => {
    setLowerBound(e[0]);
    setUpperBound(e[1]);
  };

  return (
    <div>
      <Form.Group controlId="formBasicRange">
        <h2 className="rate-slider-header">
          <NumberFormat
            value={lowerBound}
            displayType={"text"}
            thousandSeparator={true}
            prefix="$"
          />{" "}
          to{" "}
          <NumberFormat
            value={upperBound}
            displayType={"text"}
            thousandSeparator={true}
            prefix="$"
            suffix={upperBound === 1500000 ? "+" : ""}
          />
        </h2>
        <Range
          min={10000}
          max={1500000}
          step={10000}
          value={[lowerBound, upperBound]}
          defaultValue={[lowerBound, upperBound]}
          onChange={(e) => {
            handleChange(e);
          }}
        />
      </Form.Group>
    </div>
  );
};

export default RateSlider;
